import service from "@/store/services/dpa-file-service";

export const state = () => ({
  list: {},
  dpaFile: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, dpaFile) => {
    state.dpaFile = dpaFile;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((dpaFile) => {
      commit("SET_RESOURCE", dpaFile);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((dpaFile) => {
      commit("SET_RESOURCE", dpaFile);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((dpaFile) => {
      commit("SET_RESOURCE", dpaFile);
    });
  },

  confirm({ commit, dispatch }, { id, params }) {
    return service.confirm(id, params, this.$axios);
  },
  
  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  send({ commit, dispatch }, params) {
    return service.send(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  dpaFile: (state) => state.dpaFile,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((dpaFile) => ({
      id: dpaFile.id,
      name: `${dpaFile.code}`,
    }));
  },
};

const dpaFiles = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default dpaFiles;
